import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col, Card, CardBody, Spinner } from "reactstrap";
import { Bar, Pie, Line } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { FaUsers, FaUserGraduate, FaUniversity, FaRegCalendarAlt } from "react-icons/fa";
import "./InternDashboard.css";

const API_URL = "https://app.rlagency.id/api_internship/internship_applicants.php";

const InternDashboard = () => {
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApplicants();
  }, []);

  const fetchApplicants = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL);
      setApplicants(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching applicants:", error);
    }
    setLoading(false);
  };

  const totalApplicants = applicants.length;
  const batchCounts = {};
  const positionCounts = {};
  const universityCounts = {};
  const educationCounts = { kuliah: 0, lulus: 0 };
  const applicantsPerDate = {};

  applicants.forEach((applicant) => {
    batchCounts[applicant.batch] = (batchCounts[applicant.batch] || 0) + 1;
    positionCounts[applicant.position] = (positionCounts[applicant.position] || 0) + 1;
    universityCounts[applicant.university] = (universityCounts[applicant.university] || 0) + 1;
    if (applicant.status === "kuliah") educationCounts.kuliah++;
    else educationCounts.lulus++;

    const formattedDate = new Date(applicant.created_at).toLocaleDateString("id-ID");
    applicantsPerDate[formattedDate] = (applicantsPerDate[formattedDate] || 0) + 1;
  });

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    maintainAspectRatio: false,
  };

  const barChartData = (labels, data, label) => ({
    labels,
    datasets: [{
      label,
      data,
      backgroundColor: "#4285f4"
    }]
  });

  const pieChartData = {
    labels: ["Masih Kuliah", "Sudah Lulus"],
    datasets: [{
      data: [educationCounts.kuliah, educationCounts.lulus],
      backgroundColor: ["#fbbc05", "#34a853"]
    }]
  };

  const lineChartData = {
    labels: Object.keys(applicantsPerDate),
    datasets: [{
      label: "Pendaftar per Hari",
      data: Object.values(applicantsPerDate),
      borderColor: "#ea4335",
      fill: false
    }]
  };

  return (
    <Container className="intern-dashboard">
      <h2 className="dashboard-title">Internship Dashboard</h2>

      {loading ? (
        <div className="text-center my-5"><Spinner color="primary" /></div>
      ) : (
        <>
          {/* Statistik Ringkas */}
          <Row className="stat-summary">
            <Col md={3} sm={6}>
              <Card className="stat-card">
                <CardBody>
                  <FaUsers size={24} className="stat-icon" />
                  <h6>Total Pendaftar</h6>
                  <h4>{totalApplicants}</h4>
                </CardBody>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="stat-card">
                <CardBody>
                  <FaUserGraduate size={24} className="stat-icon" />
                  <h6>Masih Kuliah</h6>
                  <h4>{educationCounts.kuliah}</h4>
                </CardBody>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="stat-card">
                <CardBody>
                  <FaUserGraduate size={24} className="stat-icon" />
                  <h6>Sudah Lulus</h6>
                  <h4>{educationCounts.lulus}</h4>
                </CardBody>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="stat-card">
                <CardBody>
                  <FaUniversity size={24} className="stat-icon" />
                  <h6>Universitas Unik</h6>
                  <h4>{Object.keys(universityCounts).length}</h4>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Grafik */}
          <Row>
            <Col md={6}>
              <Card className="chart-card">
                <CardBody>
                  <h6>Pendaftar per Batch</h6>
                  <div className="chart-wrapper">
                    <Bar data={barChartData(Object.keys(batchCounts), Object.values(batchCounts), "Batch")} options={chartOptions} />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="chart-card">
                <CardBody>
                  <h6>Distribusi Posisi</h6>
                  <div className="chart-wrapper">
                    <Pie data={barChartData(Object.keys(positionCounts), Object.values(positionCounts), "Posisi")} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Card className="chart-card">
                <CardBody>
                  <h6>Pendaftar per Universitas</h6>
                  <div className="chart-wrapper">
                    <Bar data={barChartData(Object.keys(universityCounts), Object.values(universityCounts), "Universitas")} options={chartOptions} />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="chart-card">
                <CardBody>
                  <h6>Pendaftar per Tanggal</h6>
                  <div className="chart-wrapper">
                    <Line data={lineChartData} options={chartOptions} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default InternDashboard;
